import { render, staticRenderFns } from "./colegios.vue?vue&type=template&id=dc7c3546"
import script from "./colegios.vue?vue&type=script&lang=js"
export * from "./colegios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports